<!--
  Allows to handle 2mee hologram notifications. Having Appear2mee service paused or not (notifications displayed or not)
  is always a combination of global 'notificationsEnabled' and temporal 'notificationsMuted' states.

  Store states:
    notificationsEnabled - global state telling if notifications are enabled/disabled permanently
             true  - notifications can be displayed, but only if 'notificationsMuted' is set to false
             false - notifications can not be displayed at all
    notificationsMuted   - global state telling if notifications are enabled/disabled temporarily
             true  - notifications can not be displayed
             false - notifications can be displayed, but only if 'notificationsEnabled' is set to true

  Store mutations:
    toggleNotifications - toggles 'notificationsEnabled' state, committed in SettingsMenu
    muteNotifications   - sets 'notificationsMuted' state to true, committed when SettingsMenu or BurgerMenu is opened,
                          when player is playing or buffering stream (see VideoJs), when app is moved to background
    unmuteNotifications - sets 'notificationsMuted' state to false, committed when SettingsMenu or BurgerMenu is closed,
                          when player is paused, ended or failed (see VideoJs), when app is bring back to foreground
-->
<template>
  <div></div>
</template>

<script>
import { spinnakerApi } from '../js/SpinnakerApi'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      appear2meeAvailable: false
    }
  },
  computed: {
    ...mapState(['notificationsEnabled', 'notificationsMuted']),
    appear2mee () {
      return window.Appear2mee
    },
    appear2meeId () {
      return spinnakerApi.appear2meeId
    }
  },
  created () {
    this.initiateAppear2mee()

    this.unsubscribeStore = this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'toggleNotifications':
        case 'muteNotifications':
        case 'unmuteNotifications':
          this.toggleAppear2mee(state.notificationsEnabled, state.notificationsMuted)
          break
      }
    })

    window.addEventListener('focus', this.onFocus, false)
    window.addEventListener('blur', this.onBlur, false)

    this.toggleAppear2mee(this.notificationsEnabled, this.notificationsMuted)
  },
  beforeDestroy () {
    this.unsubscribeStore()
    window.removeEventListener('focus', this.onFocus)
    window.removeEventListener('blur', this.onBlur)
  },
  methods: {
    initiateAppear2mee () {
      if (!this.appear2mee) {
        console.warn('Appear2mee: Appear2mee not available, can not initiate 2mee hologram')
        return
      }
      if (!this.appear2meeId) {
        console.warn('Appear2mee: ID not defined, can not initiate 2mee hologram')
        return
      }
      try {
        this.appear2mee.initWithID(this.appear2meeId)
        this.appear2mee.setPosition('bottom')
        this.appear2meeAvailable = true
        console.info('Appear2mee: Initiated')
      } catch (exception) {
        console.error('Appear2mee: 2mee hologram initiation failed', exception)
      }
    },
    toggleAppear2mee (enabled, muted) {
      if (this.appear2meeAvailable) {
        const paused = !enabled || muted
        console.debug(`Appear2mee: enabled:${enabled}, muted:${muted} => paused:${paused}`)
        window.Appear2mee.setPause(paused)
      }
    },
    onFocus () {
      console.debug('Appear2mee: App in foreground')
      this.$store.commit('unmuteNotifications')
    },
    onBlur () {
      console.debug('Appear2mee: App in background')
      this.$store.commit('muteNotifications')
    }
  }
}
</script>
